import { useExperimentFlag } from '../../utils/useExperimentFlag';
import { PROMOTE_SHOW_IN_FEED_COLLECTIONS_KEY } from '../constants';
import { UserUI } from '../users/types';

export const useProfileSticker = (user?: UserUI) => {
    const isShowInFeedEnabled = String(useExperimentFlag('show_in_feed_enabled')) === '1';
    const isEnabled = String(useExperimentFlag('show_in_feed_onboarding_enabled')) === '1';

    const showedCollections = JSON.parse(
        localStorage.getItem(PROMOTE_SHOW_IN_FEED_COLLECTIONS_KEY) || '[]',
    );

    const promoteList = user?.promoteShowInFeedCollections;

    if (!promoteList?.length) {
        return { isVisible: false };
    }

    const filteredPromoteList = promoteList.filter(
        (collectionId) => !showedCollections.includes(collectionId),
    );

    const isPromoShowInFeedVisible = filteredPromoteList.length > 0;

    return { isVisible: isPromoShowInFeedVisible && isShowInFeedEnabled && isEnabled };
};
